function sortParamsByDisplayIndex(params) {
        if (!Array.isArray(params)) {
            throw new Error('Input must be an array');
        }
        return params.sort((a, b) => {
            let defIndex = 9999
            const indexA = a?.display_index !== null && a?.display_index !== undefined ? Number(a.display_index) : defIndex;
            const indexB = b?.display_index !== null && b?.display_index !== undefined ? Number(b.display_index) : defIndex;

            // First sort by display_index
            if (indexA !== indexB) {
                return indexA - indexB;
            }

            // If display_index is the same, sort alphabetically by label
            // Handle cases where label might be undefined or null
            const labelA = a?.label || '';
            const labelB = b?.label || '';
            return labelA.localeCompare(labelB);
        });
    }
    
    export function reorderFieldsOnlyByIndex(fields) {
        return sortParamsByDisplayIndex(fields)
    }